export default "__VITE_ASSET__CECwFD3H__"